import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import type { SplitViewContentDefinition } from './split-view.registry'
import { InvalidDataFallback } from './split-view-fallbacks.atom'
import { SplitViewWrapper } from './split-view-wrapper.atom'

export interface SplitViewInvalidProps {
  definition: SplitViewContentDefinition
  onClose: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewInvalid: React.FC<SplitViewInvalidProps> = ({
  definition,
  onClose,
  isCloseButtonHidden = false,
  className,
}): ReactNode => {
  const IconComponent = definition.icon
  const iconClassName = definition.iconClassName ?? 'text-primary'
  const iconElement = <IconComponent className={cn('size-4', iconClassName)} />

  return (
    <SplitViewWrapper
      title={definition.title}
      icon={iconElement}
      onClose={onClose}
      isCloseButtonHidden={isCloseButtonHidden}
      className={className}
    >
      <InvalidDataFallback />
    </SplitViewWrapper>
  )
}
